import '@module/LinkBox/LinkBox.js';
import '@module/Rating/Rating.js';
import '@sass/citytocity/citytocity.scss';
import { EventDispatcher, documentReady, gebi, getSearchBoxConfigFromUrl, getUrlVars, hideElement, initGoogleMaps, isDesktopView, isMobileView, isTabletView, qs, setUrlParameter } from '@utils/toolbox';
import { RecentSearches } from '@module/RecentSearches/RecentSearches.js';
import { SearchBox } from '@module/SearchBox/SearchBox';
import { pricehunter } from '@module/PriceHunter/PriceHunter';

const routes = {
	async init () {
		this.initSearchBox();
		await this.initRouteMetaMap();
		this.initPricehunter(); // Wait for pricehunter to load before initializing recent searches, this is so we can get the correct height for the recent searches container
		this.initRecentSearches();
	},

	initSearchBox () {
		window.searchBox = new SearchBox(
			{
				id: 'abSearchBox',
				dateSelector: gebi('dateselector'),
				config: getSearchBoxConfigFromUrl(js_params.urlVars),
				callbacks: {
					onPreviewReceived: function (instance, previewGroup) {
						if (previewGroup?.flights?.length) {
							instance.cancelSearch();
							location.href = instance.showresultURL;
						}
					},
					onSearchComplete: (instance) => {
						const urlVars = getUrlVars();

						if (instance.data.forceNearbyDates) {
							instance.showresultURL = setUrlParameter(instance.showresultURL, 'forceNearbyDates', 1);
						}

						if (urlVars?.filter) {
							instance.showresultURL = setUrlParameter(instance.showresultURL, 'filter', urlVars.filter);
						}

						location.href = instance.showresultURL;
					}
				}
			});
	},

	async initPricehunter () {
		const pricehunterComponent = await pricehunter.init({
			gestureHandling: isMobileView() ? 'cooperative' : 'greedy',
			zoom: 7,
			center: { ...js_params.toCoordinates }
		}, '#map');

		EventDispatcher.addEventListener('pricehunter:refreshed', () => {
			const anyMarkersInView = Object.keys(window.pricehunter_map.showingList).length > 0;

			if (!anyMarkersInView) {
				hideElement('section.container.prisjagaren');
			}
		});

		return pricehunterComponent;
	},

	initRecentSearches () {
		window.recentSearches = new RecentSearches({ recentCityToCity: true, cityFrom: js_params.fromCityIataAndMetro, cityTo: js_params.toCityIataAndMetro });

		if (isDesktopView() && qs('#recent-searches')) {
			qs('#recent-searches').style.height = qs('.map-and-facts').offsetHeight + 'px';
		}
	},

	initRouteMetaMap () {
		return new Promise((resolve) => {
			initGoogleMaps(js_params.googleApiKey, () => {
				routes.mapLoaded();
				resolve();
			});
		});
	},

	mapLoaded () {
		const { fromCoordinates, toCoordinates } = js_params;
		const options = {
			center: { lat: fromCoordinates.lat, lng: fromCoordinates.lng },
			draggable: false,
			gestureHandling: 'none',
			zoom: 10,
			disableDefaultUI: true,
			zoomControl: false,
			restriction: {
				latLngBounds: {
					north: 85,
					south: -85,
					west: -180,
					east: 180
				},
				strictBounds: false
			},
			isFractionalZoomEnabled: isMobileView() || isTabletView(),
			minZoom: 1,
			maxZoom: 11
		};


		this.map = new google.maps.Map(gebi('map__route'), options);


		// Create markers at the specified coordinates
		const fromMarker = new google.maps.Marker({
			position: fromCoordinates,
			map: this.map
		});

		const toMarker = new google.maps.Marker({
			position: toCoordinates,
			map: this.map
		});

		// Draw a line between the markers
		const linePath = new google.maps.Polyline({
			path: [fromCoordinates, toCoordinates],
			geodesic: true,
			strokeColor: '#2E5B8B',
			strokeOpacity: 1.0,
			strokeWeight: 2,
			map: this.map
		});


		// Convert coordinates to google.maps.LatLng objects
		const fromLatLng = new google.maps.LatLng(fromCoordinates.lat, fromCoordinates.lng);
		const toLatLng = new google.maps.LatLng(toCoordinates.lat, toCoordinates.lng);


		// Create a new bounds object
		const bounds = new google.maps.LatLngBounds();
		bounds.extend(fromLatLng);
		bounds.extend(toLatLng);

		// Adjust the map to fit within the bounds
		this.map.fitBounds(bounds);
	}
};

documentReady(routes.init.bind(routes));
